// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index.js'
import api from './api/config.js'
// import myapi from './api/api.js'
import '@/styles/index.scss' // global css
import './global'
import '@/styles/quill.core.css'
import '@/styles/quill.snow.css'
import '@/styles/quill.bubble.css'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper, )

Vue.config.productionTip = false

Vue.prototype.$api = api

// Vue.prototype.$myapi = myapi
Vue.prototype.baseURL = process.env.API_ROOT
Vue.prototype.opURL = process.env.OP_ROOT
Vue.prototype.baseQrcodeURL = 'https://xinli-api-t.gongyi.la'
new Vue({
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
}).$mount("#app")



// WEBPACK FOOTER //
// ./src/main.js